/**
 * Jet-wash spray kicked up from the water under the jet (GDD §3.4: 60 particles per second; concept L1296–L1301).
 * Reuses one emission spec, so spraying allocates nothing.
 */
import type { Rng } from '../core/rng.ts';
import type { FlightState } from '../sim/flight.ts';
import type { ParticleSpec, Particles } from './particles.ts';

export interface Spray {
  /** Fractional particles carried to the next step. */
  acc: number;
  step(flight: FlightState, dt: number, alive: boolean): void;
}

export function createSpray(particles: Particles, rand: Rng, canyon = false): Spray {
  const spec: ParticleSpec = {
    kind: 'mist',
    x: 0,
    y: 0.3,
    z: 0,
    vx: 0,
    vy: 0,
    vz: 0,
    drag: 1.5,
    grav: -2,
    life: 1,
    s0: 2,
    s1: canyon ? 7 : 9,
    a0: canyon ? 0.35 : 0.22,
    bright: 1.1,
  };
  const spray: Spray = {
    acc: 0,
    step(flight, dt, alive) {
      if (!alive) return;
      spray.acc += dt * (flight.y < 14 ? 60 : 26);
      while (spray.acc > 1) {
        spray.acc -= 1;
        spec.x = flight.x + (rand() - 0.5) * 6;
        spec.z = flight.z + 4 + rand() * 10;
        spec.vx = (rand() - 0.5) * 8 + flight.vx * 0.2;
        spec.vy = 1 + rand() * 3;
        spec.vz = 6 + rand() * 6;
        spec.life = 0.9 + rand() * 0.8;
        particles.emit(spec);
      }
    },
  };
  return spray;
}
